<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <transition name="fade">
          <b-card no-body v-if="show">
            <div slot="header">
              <i class="fa fa-map-o"></i> Map
            </div>
            <b-row class="flex-nowrap no-gutters">
              <b-col class="col-md-3 col-xs-5">
                <b-card-body>
                  <b-form>
                    <b-form-group>
                      <b-tabs v-model="tabIndex">
                        <b-tab title="Search by location" active>
                            <b-input-group>
                              <gmap-autocomplete
                                  v-focus
                                  ref='origin'
                                  @place_changed="setPlace($event)"
                                  placeholder="Search location ..."
                                  :componentRestrictions="options"
                                  class="form-control">
                              </gmap-autocomplete>
                              <b-input-group-append>
                                 <b-button variant="secondary" @click="initMapClickEventHandler" title="Select point of interest on the map" ><i class="fa fa-map-marker"></i></b-button>
                              </b-input-group-append>
                            </b-input-group>  
                        </b-tab>
                        <b-tab title="Search by lat/lng">
                            <b-input-group>
                              <b-form-input ref="latlng" type="text" v-model="latlng" placeholder="Enter latitude, longitude"></b-form-input> 
                              <!-- Attach Right button -->
                              <b-input-group-append>
                                 <b-button variant="secondary" @click="findLocation"><i class="fa fa-search"></i></b-button>
                              </b-input-group-append>
                            </b-input-group>                            
                        </b-tab>
                        <b-tab title="Upload GPS locations">
                            <b-form-group>
                               <file-upload
                                    ref="fileUpload"
                                    :have-desc="false"
                                    title=""
                                    accept=".csv, .txt"
                                    @event-handler="fileUploadEventHandler($event)">            
                                  </file-upload> 
                            </b-form-group>
                        </b-tab>                          
                      </b-tabs>                      
                    </b-form-group>

                    <br>
                    <div slot="footer">
                      <i class="fa fa-lightbulb-o text-warning fa-1x" style="padding-bottom: 15px"></i> <small>Click <b>Capture</b> button to confirm the location.</small><br>
                      <b-button @click="captureEventHandler" type="button" size="sm" variant="success"><i class="fa fa-camera"></i> Capture</b-button>&nbsp;
                      <b-button @click="closeEventHandler" type="button" size="sm" variant="secondary"><i class="fa fa-close"></i> Close</b-button><br>
                    </div>                   
                  </b-form>                  
                </b-card-body>  
              </b-col>              
              <b-col class="col-md-9" ref="capture">
                  <gmap-map
                    :center="defaultLocation" :zoom="7"
                    map-type-id="roadmap"
                    :style="mapStyles" ref="mapRef">
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :animation=2
                      :clickable="true"
                      :draggable="true"
                      @dragend="dragend(index, $event)"
                      @click="mapClickEventHandler"
                      :ref="markerRef">
                      </gmap-marker>
                    </gmap-map>                    
                    <!-- //@click="center=m.position" -->
              </b-col>
            </b-row>                   
          </b-card>          
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { gmapMixin } from '@/mixins/gmapMixin'
import * as types from '@/store/types'
import * as utils from '@/mixins/utils'
import * as constants from '@/store/constants'
import FileUpload from '@/components/file-upload/FileUpload'
import UploadService from '@/api/UploadService'

export default {
  components: { 
    FileUpload
  },  
  mixins: [gmapMixin],
  props: {
    options: { type: Object, 
               default() { 
              return { country: 'YE' }
      }
    }    
  },
  data () {
    return {
      output: null,
      selected: [], // Must be an array reference!
      show: true,
      disabledCapture: true,
      showRouteInfo: false,
      routeInfoHeader: null,
      markers: [],      
      places: [],
      currentPlace: null,
      targetObject: null,
      mapStyles: 'width: 100%; height:' + (window.innerHeight - 250) + 'px',
      routeInfoStyle: 'padding:0px;position:relative; height:300px; overflow-y:scroll;',
      map: null,
      markerRef: null,
      title: '0 km',
      total: 0,
      stops: [],
      waypoints: [],
      currentWaypoint: null,      
      legs: [],
      directionsDisplay: null,
      searchAddressInput: '',
      defaultLocation: {lat:15.5, lng:47.5},
      segmentMarkers: [],
      center: null,
      latlng: null,
      lat: 0,
      lng: 0,
      tabIndex: 0,
      selectPOI: false
    }
  },
  computed: {
    
  },
  watch: {
    mapStyles () {
      // loaded.then(() => {
      //   var bounds = new google.maps.LatLngBounds()
      //   console.log(bounds)
      // })
    }
  },
  methods: {

     async fileUploadEventHandler(event) {
      const notificationId = this.$store.state.notificationId
      const requestTypeId = this.$store.state.requestTypeId
      const category = "GPS_DOCUMENT"
      const $this = this
      const _self = this
      this.showUploadError = false
      
      let file = event.file
      if (!file) return

      // validate if file exceeds 1mb
      if (file.size >= constants.FILE_MAXIMUM_SIZE) {
          this.showUploadError = true
          return
      }

      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true
      
      await UploadService.gps(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
          if (resp && resp.length > 0) {
              _self.drawVenue(resp)
          }          
      })
    },

    drawVenue(resp) {

      const _self = this
      
      for (var i = 0; i < resp.length; i++) {
        let o = resp[i]

        console.log(o.lat +", "+ o.lng)

        _self.markers.push({
                position: {
                  lat: o.lat,
                  lng: o.lng
                }
            })
      }
    },

    initMapClickEventHandler() {
      this.markers = [] 
      this.selectPOI = true 
      this._map.setOptions({draggableCursor:'crosshair'});      
    },

    mapClickEventHandler(e) {
      if (this.selectPOI) {
          this.selectPOI = false
          let marker = {
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng()
              }      
          this.markers.push({ position: marker })
          this.lat = e.latLng.lat().toFixed(6)
          this.lng = e.latLng.lng().toFixed(6)

          this.latlng = this.lat +", "+ this.lng
          this._map.setOptions({draggableCursor:''});
          this.findLocation() 
      }
    },
    // receives a place object via the autocomplete component
    setPlace (place) {
      console.log("*************")
      console.log(place)
      console.log("*************")
      this.currentPlace = place      
      this.lat = place.geometry.location.lat().toFixed(6)
      this.lng = place.geometry.location.lng().toFixed(6)
      this.addMarker()
    },

    captureEventHandler () {

        for (let i = 0; i < this.markers.length; i++) {

            this.lat = this.markers[i].position.lat.toFixed(6)
            this.lng = this.markers[i].position.lng.toFixed(6)

            // Set static map URL
            let staticMapURL = "https://maps.googleapis.com/maps/api/staticmap?center=::CENTER::&zoom=::ZOOM::&scale=1&size=640x640&maptype=::MAP_TYPE::&format=png&visual_refresh=true&::MARKERS::&key=AIzaSyAw-RrzY2H4pCwu9aiUW3B6LPBYmWfirPo"
            staticMapURL = staticMapURL.replace("::CENTER::", this.lat +','+ this.lng)
            staticMapURL = staticMapURL.replace("::MAP_TYPE::", 'satellite')  // this._map.getMapTypeId()
            staticMapURL = staticMapURL.replace("::ZOOM::", 18)

            let _markers = "markers=size:mid|color:0xff00cl00|label:A|"+ this.lat +','+ this.lng
            staticMapURL = staticMapURL.replace("::MARKERS::", _markers)

            console.log(staticMapURL)
            let idx = this.$store.state.temp_venue.venues.length

            if (this.$store.state.map_index > 0) {
                let row = this.$store.state.map_index
                let venue = this.$store.state.temp_venue.venues[row]            
                venue.city = (this.currentPlace ? this.currentPlace.formatted_address : '')
                venue.gps = this.lat +', '+ this.lng            
                venue.static_map = staticMapURL

                this.$store.state.temp_venue.venues[row] = venue
                this.$store.commit(types.MUTATE_MAP_MODIFIED, false)
            }
            else {
                // store to state  
                let dStartDate = this.$moment(this.$store.state.start_date).format('HH:mm:ss')
                let startTime = this.$moment(this.$store.state.start_date).format('HH:mm:ss')

                let departureFormat = "YYYY-MM-DDT"+ startTime +"Z"
                let arrivalFormat = "YYYY-MM-DDT18:00:00Z"

                let departureDate = this.$moment(this.$store.state.start_date).format( departureFormat )
                let arrivalDate = this.$moment(this.$store.state.start_date).format( arrivalFormat )

                console.log("departureDate: "+ departureDate)
                console.log("arrivalDate  : "+ arrivalDate)

                let obj = { notification_id: 0, 
                        city: (this.currentPlace ? this.currentPlace.formatted_address : ''), 
                        gps: this.lat +', '+ this.lng, venue_name: '',
                        date_from: departureDate,
                        date_to: arrivalDate,
                        static_map: staticMapURL
                      }

                this.$store.state.temp_venue.venues.push(obj)
            }
        }

        this.$store.commit(types.MUTATE_MODIFIED, true)        
        this.$router.replace('/forms/'+ this.$route.query.param)
    },

    closeEventHandler() {
      this.$router.replace('/forms/'+ this.$route.query.param)
    },

    findLocation() {
      
      // reset marker
      this.markers = []
      const $this = this      
      var latlngStr = this.latlng.split(',', 2)
      // var latlng = {lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1])}

      let marker = {
                  lat: parseFloat(latlngStr[0]),
                  lng: parseFloat(latlngStr[1])
                }            

      //$this.$refs.origin.$el.value = results[0].formatted_address
      $this.markers.push({ position: marker })
                
      // var geocoder = new google.maps.Geocoder()
      // geocoder.geocode({'location': latlng}, (results, status) => {
      //   if (status === 'OK') {
      //       if (results[0]) {

      //           console.log(results[0])
      //           this.currentPlace = results[0]

      //           console.log("lat: "+ results[0].geometry.location.lat().toFixed(6))
      //           console.log("lng: "+ results[0].geometry.location.lng().toFixed(6))
      //           let _lat = results[0].geometry.location.lat().toFixed(6)
      //           let _lng = results[0].geometry.location.lng().toFixed(6)

      //           $this.lat = _lat
      //           $this.lng = _lng
      //           let marker = {
      //             lat: parseFloat(_lat),
      //             lng: parseFloat(_lng)
      //           }            

      //           $this.$refs.origin.$el.value = results[0].formatted_address
      //           $this.markers.push({ position: marker })
      //           //this.centerMap()
      //       }
      //   } 
      //   else {
      //     alert('Geocode was not successful for the following reason: ' + status);
      //   }
      // });
    },    
    
    dragend (index, e) {
        const $this = this 
        this._map.panTo(e.latLng)        
        var geocoder = new google.maps.Geocoder()
        let latlng = {lat: parseFloat(e.latLng.lat()), lng: parseFloat(e.latLng.lng())};

        console.log(latlng)

        geocoder.geocode({'location': latlng}, (results, status) => {
        if (status === 'OK') {

            if (results[0]) {
                this.currentPlace = results[0] 
                this.lat = e.latLng.lat().toFixed(6)
                this.lng = e.latLng.lng().toFixed(6)                

            //if (this.tabIndex === 1 )
                $this.$refs.latlng.$el.value = this.lat + ", "+ this.lng
            //else 
              $this.$refs.origin.$el.value = results[0].formatted_address
            }            
        } 
        else {
          alert('Geocode was not successful for the following reason: ' + status);
        }
      });
    },
    addMarker (action) {

      if (this.currentPlace) {
          let marker = {
              lat: this.currentPlace.geometry.location.lat(),
              lng: this.currentPlace.geometry.location.lng()
          }

          this.places.push(this.currentPlace)
          this.markers.push({ position: marker })
          //this.centerMap()
      }
    },

    centerMap() {
        let bounds = new google.maps.LatLngBounds()

        for (let i = 0; i < this.markers.length; i++) {
          bounds.extend(this.markers[i].position)
        }
        this._map.fitBounds(bounds)
        // if (this.markers.length === 1) {
        //     this._map.setZoom(15)
        // }

        console.log( this._map.getCenter() )
        this.center = this._map.getCenter().lat()+','+this._map.getCenter().lng()
    }
  },
  computed: {
      
  },
  mounted () {
    
    this.$refs.mapRef.$mapPromise.then((map) => {
      this._map = map
      this._map.setOptions({ minZoom: 7, maxZoom: 22});
      this._map.addListener('click', this.mapClickEventHandler.bind(this));
    })

    // window listener
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.mapStyles = 'width: 100%; height:' + (window.innerHeight - 250) + 'px'
        this.routeInfoStyle = 'padding:0px;position:relative; height:'+ (window.innerHeight - 500) +'px; overflow-y:scroll;'
      })
    })
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.vue-map-container,
.vue-map-container .vue-map {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/map/MapSearch.vue